import { useContext } from 'react';
import { BoardTypeFieldContext } from '../boardContext';

export default function useBoardConfig() {
  return useContext(BoardTypeFieldContext) || {};
}
